import { deleteFromLocalStorage } from 'src/utils'

// Unscoped legacy keys written when getScopedAppliedPromoKey() returns null
// (e.g. country code could not be resolved from the locale).
const UNSCOPED_PROMO_CODE_KEYS = [
  'appliedPromoCode',
  'appliedPromoPrevious',
  'appliedPromoCurrent',
]

/**
 * Clears all applied promotion codes from localStorage.
 * Prevents cross-account promotion persistence by removing all keys
 * prefixed with 'appliedPromoCode_', as well as the unscoped legacy keys
 * used when country-scoped key resolution fails.
 *
 * @function clearAppliedPromoCodes
 * @returns {void}
 */
export const clearAppliedPromoCodes = () => {
  // Guard against SSR or non-browser environments
  if (typeof window === 'undefined' || !window.localStorage) return

  try {
    const keysToDelete = Object.keys(localStorage).filter(key =>
      key.startsWith('appliedPromoCode_')
    )
    keysToDelete.forEach(key => deleteFromLocalStorage(key))
    UNSCOPED_PROMO_CODE_KEYS.forEach(key => deleteFromLocalStorage(key))
  } catch (e) {
    console.warn('Fn clearAppliedPromoCodes', e)
  }
}
